var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){$event.preventDefault();return _vm.onClickPick.apply(null, arguments)}}},[_vm._t("default"),(_vm.isLoading)?_c('v-overlay',[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }